import { object, string } from 'yup';
export const uploadVideoValidationSchema = object().shape({
  title: string().required('Title is required'),
  // video: mixed().required('Video is required'),
  // thumbnail: mixed().required(),
  // description: string().required('Description is required'),
  // tagIds: string().required('Choose at least one tag'),
});
